import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
import { STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_BY_BRAND, ORDER_ASCENDING, NEGOTIATION_PHASE } from '../Utils/Constants';
const sControllerEndpoint = 'LotCreationL1';
const L4ControllerEndpoint = 'LotCreationL4';

export class UsedRentalsAPI {
  params;

  constructor() {
    this.params = {};
  }

  getRUCreationLots(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, state = NEGOTIATION_PHASE, searchBy = '') {
    this.params = {
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (state)
      this.params.state = state;
    if (searchBy)
      this.params.searchBy = searchBy;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetListLotL1RU', { params: this.params });
  }

  cancelNegotiationLot(id, sNegLotCancelationObservation) {
    this.params = {
      id: id,
      cancelRuObservations: sNegLotCancelationObservation
    }
    return axios.delete(getBackendURL() + sControllerEndpoint + '/CancelLotL1RU', { params: this.params });
  }

  saveNewNegotiationLot(dto) {
    return axios.post(getBackendURL() + sControllerEndpoint + '/CreateLotL1RU', dto);
  }

  editNegotiationLot(dto) {
    return axios.put(getBackendURL() + sControllerEndpoint + '/UpdateLotL1RU', dto);
  }

  getRULotById(ruL1Id) {
    this.params = {
      ruL1Id: ruL1Id
    }
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetRULotById', { params: this.params });
  }

  finishNegotiationLot(lotId) {
    return axios.post(getBackendURL() + L4ControllerEndpoint + '/CreateListCarL4RU?lRuL1Id=' + lotId);
  }

  duplicateNegotiationLot(lotId) {
    return axios.put(getBackendURL() + sControllerEndpoint + '/CopyLotL1RU?ruLotId=' + lotId);
  }
  
}

export default UsedRentalsAPI


// WEBPACK FOOTER //
// ./src/API/UsedRentalsAPI.js